import React, { Component } from "react";
import AllResultsContainer from "./AllResultsContainer";
import FilteredResultsContainer from "./FilteredResultsContainer";
import Staff from "./Staff";
import TelList from "./TelList";
class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: window.scoeWebSite.staffDirectory.data,
      apiEndpoint: window.scoeWebSite.staffDirectory.apiEndpoint,
      searchString: "",
      isAuthed: window.scoeWebSite.isAuthed,
      loading: true,
      placeholder: window.scoeWebSite.staffDirectory.placeholderText
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    function formatFixes(dat) {
      function fixPhone(rsp) {
        function fp(ph) {
          return ph.replace(
            /(\([2-9][0-9][0-9]\) [2-9][0-9][0-9])(-[0-9][0-9][0-9][0-9])\/(-[0-9][0-9][0-9][0-9])/,
            "$1$2/$1$3"
          );
        }
        return rsp.map(r => {
          const p1 = r["Phone Number Combined"];
          if (p1) r["Phone Number Combined"] = fp(p1);
          const p2 = r["Phone 2 Number Combined"];
          if (p2) r["Phone 2 Number Combined"] = fp(p2);
          return r;
        });
      }
      return fixPhone(dat);
    }

    if (!this.state.data) {
      this.setState({ loading: true });
      fetch(this.state.apiEndpoint, {
        headers: {
          Accept: "application/json"
        }
      })
        .then(response => response.json())
        .then(data =>
          this.setState({ loading: false, data: formatFixes(data) })
        );
    } else {
      this.setState({ loading: false, data: formatFixes(this.state.data) });
    }
  }
  handleChange(event) {
    const { checked, type, value: val, name } = event.target;
    const value = type === "checkbox" ? checked : val;
    this.setState({
      [name]: value
    });
  }

  render() {
    if (this.state.loading) return null;
    const searchString = this.state.searchString.toLowerCase();

    function formatPhForSearch(ph) {
      return ph ? ph.replace(/[() -]/g, "").replace(/[^0-9][^0-9]*/g, " ") : "";
    }
    const staffFilter = searchString
      ? ({
          "First Name": fn,
          "Last Name": ln,
          "Staff Title": st,
          "Department for Staff Directory Text": dn,
          "Phone Number Combined": pn,
          "Phone 2 Number Combined": pn2,
          "Email Address": em,
        }) => {
          return (
            `${fn} ${ln} ${st} ${dn} ${em.join(' ')} ${formatPhForSearch(pn)}${
              this.isAuthed ? " " + formatPhForSearch(pn2) : ""
            }`
              .toLowerCase()
              .indexOf(searchString) > -1
          );
        }
      : () => true;

    //page was janky, maybe not running empty filters would help.
    let filteredStaff = searchString ? this.state.data : [];
    if (searchString && !this.state.loading) {
      filteredStaff = filteredStaff.filter(staffFilter);
    }

    return (
      <AllResultsContainer
        loading={this.state.loading}
        inputHandleOnChange={this.handleChange}
        count={filteredStaff.length}
        placeholder={this.state.placeholder}
      >
        {this.state.loading ? (
          ""
        ) : (
          <div>
            <FilteredResultsContainer itemType="Staff">
              {filteredStaff.map(d => {
                return (
                  <Staff
                    name={`${d["First Name"]} ${d["Last Name"]}`}
                    title={d["Staff Title"]}
                    department={d["Department for Staff Directory Text"]}
                    emails={d["Email Address"] || []}
                  >
                    <React.Fragment>
                      <TelList phone={d["Phone Number Combined"]}></TelList>
                      {this.state.isAuthed ? (
                        <TelList phone={d["Phone 2 Number Combined"]}></TelList>
                      ) : (
                        ""
                      )}
                    </React.Fragment>
                  </Staff>
                );
              })}
            </FilteredResultsContainer>
          </div>
        )}
      </AllResultsContainer>
    );
  }
}

export default Main;
